module.exports = __webpack_public_path__ + "static/media/animation_product_creation.cbbbe0ab.gif";